import { ConcreteEncodable } from "./ConcreteEncodable";

import { DealConfirmationImplEncoder } from "../../encoder/DealConfirmationImplEncoder";

import * as CubiqTS from "../../index";
import { DealConfirmation } from "../DealConfirmation";

export class DealConfirmationImpl extends ConcreteEncodable implements DealConfirmation {
  public static enType: string = "com.bcdfx.model.DealConfirmationImpl";

  /*FID=100*/
  public messageId: string;
  /*FID=220*/
  public bookingUTI: string;
  /*FID=221*/
  public acknowledged: boolean;
  /*FID=222*/
  public descriptor: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = DealConfirmationImplEncoder.Instance;
    this.setEncodableType(DealConfirmationImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "DealConfirmationImpl[" +
      "messageId=" +
      this.messageId +
      "bookingUTI=" +
      this.bookingUTI +
      "acknowledged=" +
      this.acknowledged +
      "descriptor=" +
      this.descriptor +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
